/**
 * Formats the stream range start timestamp for use in the document title.
 * Output format: "{short weekday} {day} {month short} {HH:mm}" (e.g. "Lun 19 Feb 10:30").
 * Uses Intl.DateTimeFormat with formatToParts to keep the order consistent across locales.
 */
export function formatStreamStartForTitle(from: number, locale: string, timeZone: string): string {
  const date = new Date(from);
  const formatter = new Intl.DateTimeFormat(locale, {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone,
  });
  const parts = formatter.formatToParts(date);
  const byType = Object.fromEntries(parts.map((p) => [p.type, p.value]));
  const rawWeekday = byType.weekday ?? '';
  const weekday = rawWeekday.length > 0 ? rawWeekday[0].toUpperCase() + rawWeekday.slice(1) : '';
  const day = byType.day ?? '';
  const month = byType.month ?? '';
  const hour = byType.hour ?? '';
  const minute = byType.minute ?? '';
  return `${weekday} ${day} ${month} ${hour}:${minute}`;
}
